export default __webpack_public_path__ + "static/media/add_dark.18bcb450.svg";